import { Component } from "react";

// Catches render errors in one part so the rest of the page keeps working.
class SafeBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(`[LiveEvents] ${this.props.name || "Component"} failed:`, error);
  }

  render() {
    if (this.state.hasError) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default SafeBoundary;
